import $ from 'wee-dom';

export default class CalcSlide {
    constructor(el, initialValue = 0) {
        this.init(el, initialValue);
        this.updateRate();
        this.updateSliderValue(this.$element);
    }

    value() {
        return this.$input.val();
    }

    init(el, initialValue) {
        this.$element = $(el);
        this.$input = $('input', el);
        this.$title = $('.calculator-earnings_rate-title', el);
        this.isActive = initialValue != 0;
        this.data = this.setData();
        this.$input.val(initialValue);
        this.maxValue = this.getMax();
        this.updateSliderLabel();

        if (this.data[0].activeByDefault) {
            this.activeByDefault = true;
            this.isActive = true;
            this.$input.addClass('-active').removeClass('-inactive');
            this.$title.addClass('-active').removeClass('-inactive');
        } else if (this.isActive) {
            this.$input.addClass('-active').removeClass('-inactive');
            this.$title.addClass('-active').removeClass('-inactive');
        }
    }

    updateSliderValue($rate) {
        const $amount = $('.calculator_range-amount', $rate);
        const sliderVal = parseInt(this.value());
        const formatted = sliderVal.toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        $amount.text('$' + formatted);

        if (this.getPercent() >= 25 && this.getPercent() <= 75) {
            $amount.css('left', (this.getPercent() - 50) + '%');
        } else if (this.getPercent() > 50) {
            $amount.css('left', ((this.getPercent() - 50) - 2) + '%');
        } else {
            $amount.css('left', ((this.getPercent() - 50) + 2) + '%');
        }
    }

    updateSliderLabel() {
        $('.calculator_range-amount', this.$element)
            .text(`$${Math.round(this.value()).toLocaleString('en-US')}`)
            .addClass('-visible');
    }

    getValueGroupId() {
        const newKeys = this.data.filter(
            key => this.$input.val() >= key.min && this.$input.val() <= key.max
        );

        return newKeys[0].id;
    }

    getPercent() {
        return (Number(this.value()) / Number(this.maxValue)) * 100;
    }

    setData() {
        const dataObjKeys = Object.keys(this.$input.data());

        this.fixedBonus = this.$input.data().sliderFixedBonus
            ? this.$input.data().sliderFixedBonus
            : null;

        const rates = dataObjKeys.filter(key => key.match(/sliderRate\d*/g));
        const valueRangeSets = [];

        rates.forEach((rate) => {
            const id = Number(rate.replace('sliderRate', ''));
            valueRangeSets.push({
                id,
                activeByDefault: this.$input.data().sliderDefault,
                rate: this.$input.data()[`sliderRate${id}`],
                max: this.$input.data()[`sliderMaxRange${id}`],
                min: this.$input.data()[`sliderMinRange${id}`],
            });
        });

        return valueRangeSets;
    }

    getMax() {
        let sliderMax = [...this.data][0].max;

        if (this.data.length > 1) {
            for (let i = 0; i < this.data.length; i++) {
                sliderMax = (this.data[i].max > sliderMax) ? this.data[i].max : sliderMax;
            }
        }

        return sliderMax;
    }

    updateRate() {
        this.valueGroupId = this.getValueGroupId();
        this.rate = this.data[this.valueGroupId].rate;
    }

    getTotal() {
        this.updateRate();
        const value = this.fixedBonus
            ? (Number(this.value()) * this.rate) + Number(this.fixedBonus)
            : (Number(this.value()) * this.rate);

        return Math.round(value);
    }
}
